/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/. */

import Storage from './storage';

const THEME_KEY = 'theme_preference';

export type ThemePreference = 'light' | 'dark' | 'system';

const storage = Storage.factory('localStorage');

export function getStoredTheme(): ThemePreference {
  try {
    const stored = storage.get(THEME_KEY);
    if (stored === 'light' || stored === 'dark' || stored === 'system') {
      return stored;
    }
  } catch {
    // localStorage may be unavailable (disabled, private browsing, etc.)
  }
  return 'light';
}

export function setStoredTheme(theme: ThemePreference): void {
  try {
    storage.set(THEME_KEY, theme);
  } catch {
    // localStorage may be unavailable
  }
}

export function getSystemTheme(): 'light' | 'dark' {
  if (typeof window !== 'undefined' && window.matchMedia) {
    return window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light';
  }
  return 'light';
}

export function getEffectiveTheme(
  preference: ThemePreference
): 'light' | 'dark' {
  return preference === 'system' ? getSystemTheme() : preference;
}
